import {createApp} from 'customVue';
import SearchForm from "./SearchForm";

const app = createApp({
    components: {
        SearchForm
    }
});

app.mount('#search-form-vue');
